import { render, staticRenderFns } from "./StudentSubjectReportUpload.vue?vue&type=template&id=6e8b1666&"
import script from "./StudentSubjectReportUpload.vue?vue&type=script&lang=ts&"
export * from "./StudentSubjectReportUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports